import { AudienceSyncTimeBasedSchedule, WeekDay, WeekDays, WeekDayShortNames } from '@/models/audiences';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceSyncRepeatWeekdayProps = {
  scheduleConfiguration: AudienceSyncTimeBasedSchedule;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

type Day = {
  id: WeekDay;
  label: string;
  selected: boolean;
};

export const AudienceSyncRepeatWeekday: FC<AudienceSyncRepeatWeekdayProps> = ({ scheduleConfiguration, setFieldValue }) => {
  const { t } = useTranslation('ALL');

  const initialDays = scheduleConfiguration.weekDays || [];
  const [days, setDays] = useState<Day[]>(
    WeekDays.map((weekday, index) => ({
      id: weekday,
      label: WeekDayShortNames[index],
      selected: initialDays.indexOf(weekday) > -1,
    }))
  );

  useEffect(() => {
    setFieldValue(
      'scheduleConfiguration.weekDays',
      days.filter((day) => day.selected).map((day) => day.id)
    );
  }, [days]);

  const onDayClick = (days: Day[], clickedDay: Day) => {
    setDays(days.map((day) => (day.id !== clickedDay.id ? day : { ...day, selected: !clickedDay.selected })));
  };

  return (
    <div className='flex flex-row items-center space-x-2'>
      <span className={'mr-2'}>{t('on')}</span>
      {days.map((day) =>
        day.selected ? (
          <span
            key={day.id}
            className='flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 border-blue-600 bg-blue-600'
            onClick={() => onDayClick(days, day)}
          >
            <span className='text-sm text-white-100'>{day.label}</span>
          </span>
        ) : (
          <span
            key={day.id}
            className='flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 border-gray-200 bg-gray-200'
            onClick={() => onDayClick(days, day)}
          >
            <span className='text-sm text-gray-700'>{day.label}</span>
          </span>
        )
      )}
    </div>
  );
};
